import script from "./agentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./agentPage.vue?vue&type=script&setup=true&lang=ts"

import "./agentPage.vue?vue&type=style&index=0&id=255e9c9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255e9c9f"]])

export default __exports__